module.exports = __webpack_public_path__ + "static/media/userProfileBg.cc32c47c.jpg";